/* Dopasuj do pupila: kies dier en maat, krijg advies en een kant-en-klaar bericht. Gebruikt de naam uit de hero. */
(function () {
  if (typeof customElements === 'undefined' || customElements.get('pet-match')) return;
  customElements.define('pet-match', class extends HTMLElement {
    connectedCallback() {
      var self = this;
      this.animal = ''; this.size = '';
      this.result = this.querySelector('[data-pm-result]');
      this.groups = { animal: Array.from(this.querySelectorAll('[data-pm-animal]')), size: Array.from(this.querySelectorAll('[data-pm-size]')) };
      ['animal', 'size'].forEach(function (k) {
        self.groups[k].forEach(function (b) {
          b.addEventListener('click', function () {
            self[k] = b.getAttribute('data-pm-' + k);
            self.groups[k].forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
            self.update();
          });
        });
      });
    }
    update() {
      if (!this.animal || !this.size) return;
      var pet = window.LapusiePet && window.LapusiePet.get();
      var name = pet && pet.name ? pet.name : '';
      var tpl = this.getAttribute(name ? 'data-named' : 'data-anon');
      var title = tpl.replace('{name}', name).replace('{animal}', this.animal).replace('{size}', this.size.toLowerCase());
      this.querySelector('[data-pm-title]').textContent = title;
      var product = this.getAttribute('data-product');
      var subject = this.getAttribute('data-subject').replace('{product}', product);
      var body = (name ? name + ': ' : '') + this.animal + ', ' + this.size.toLowerCase() + '. ' + product;
      this.querySelector('[data-pm-mail]').href = 'mailto:' + this.getAttribute('data-email') + '?subject=' + encodeURIComponent(subject) + '&body=' + encodeURIComponent(body);
      this.result.hidden = false;
    }
  });
})();
